export default function ShopScreen() {
  return (
    <div className="app-screen placeholder-screen">
      <div className="app-screen-header">
        <span className="app-screen-title">Shop</span>
      </div>
      <div className="placeholder-content">
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
        <p className="placeholder-title">Shop Coming Soon</p>
        <p className="placeholder-sub">Browse exclusive ROKC AR merch including the Freedom Fighters, the Pioneers, and other collections.</p>
        <a href="https://www.rockablock.com/" target="_blank" rel="noopener noreferrer">
          <button className="profile-edit-btn">
              rockablock.com
            </button>
        </a>
      </div>
    </div>
  )
}
